import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

function PartnersSalesLayout() {

    const [stores, setStores] = useState([]);

    useEffect(() => {
        fetchStores()
    }, []);

    const fetchStores = async () => {
        await requester.findAllStoresByVendorUserName((result) => {
            setStores(result.data);
            console.log(result.data)
        });
    }

    return (
        <Container>
            <Outlet context={{ stores }} />
        </Container>

    );
} export default PartnersSalesLayout;